import React from 'react'
import {useStyles} from "./ScoredSceneStatusIndication.css";
import {useIntl} from "react-intl";
import generalConfig from "../../../associationStructure/generalConfig.json";
import {Check, Close, FormatListBulleted, SquareFoot} from "@mui/icons-material";
import BasicHint from "../../hint/BasicHint";
import ScoredSceneStatusHistorySummary from "./ScoredSceneStatusHistorySummary";

const ScoredSceneStatusIndication = ({statusInfo, size = 'regular'}) => {
    const classes = useStyles()

    // Internationalization for simple strings
    const intl = useIntl();

    const status = statusInfo?.status

    if (!generalConfig.scoredSceneStatus.includes(status)) {
        return status || ''
    }

    if (size === 'small') {
        if (status === 'draft') {
            return <SquareFoot/>
        }
        if (status === 'approved') {
            return <Check/>
        }
        if (status === 'rejected') {
            return <Close/>
        }
    }

    return <div className={classes[status]}>
        <div>
            {intl.formatMessage({
                id: `app.ids.scoredSceneStatus.${status}`,
                defaultMessage: status
            })}
        </div>
        <div className={classes.historyIconContainer}>
            <BasicHint options={{trigger: "click", placement: 'bottom'}}
                       hintText={<ScoredSceneStatusHistorySummary statusInfo={statusInfo}/>}
                       element={<FormatListBulleted/>}/>
        </div>
    </div>
}
export default ScoredSceneStatusIndication